export default "__VITE_ASSET__Bk9AD7HF__"